import { render, staticRenderFns } from "./AdvancedRevision.vue?vue&type=template&id=38ec30e1&"
import script from "./AdvancedRevision.vue?vue&type=script&lang=js&"
export * from "./AdvancedRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports